import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
const initialState = {
  banners: [],
  topGames: [],
  loading: false,
  error: null,
};

const Website = createSlice({
  name: "website",
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action) => {
      if (action.payload) {
        state.banners = action.payload.banners;
        state.topGames = action.payload.topGames;
      }
      state.loading = false;
      state.error = null;
    },
    setBanner: (state, action) => {
      const index = state.banners.findIndex(
        (r) => r._id === action.payload._id
      );
      if (index !== -1) {
        state.banners[index] = action.payload;
      }
    },
    setGame: (state, action) => {
      const index = state.topGames.findIndex(
        (r) => r._id === action.payload._id
      );
      if (index !== -1) {
        state.topGames[index] = action.payload;
      }
    },
    removeBanner: (state, action) => {
      state.banners = state.banners.filter((r) => r._id !== action.payload);
    },
    removeGame: (state, action) => {
      state.topGames = state.topGames.filter((r) => r._id !== action.payload);
    },
    addBanner: (state, action) => {
      // insert new Banner method at start
      state.banners.push(action.payload);
    },
    addGame: (state, action) => {
      // insert new Banner method at start
      state.topGames.push(action.payload);
    },
    fetchFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Actions
export const {
  fetchStart,
  fetchFailure,
  fetchSuccess,
  setBanner,
  removeBanner,
  addBanner,
  addGame,
  setGame,
  removeGame,
} = Website.actions;

// Create Banner method
export const AddNewBanner = (payload) => async (dispatch) => {
  try {
    const res = await axios.post("/private/backend/website/banner", payload);
    if (res && res.data) {
      // add locally and stop loading
      dispatch(addBanner(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

export const AddNewGame = (payload) => async (dispatch) => {
  try {
    const res = await axios.post("/private/backend/website/game", payload);
    if (res && res.data) {
      // add locally and stop loading
      dispatch(addGame(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

// Update payment method
export const UpdateBanner = (id, payload) => async (dispatch) => {
  try {
    const res = await axios.put(
      `/private/backend/website/banner/${id}`,
      payload
    );
    if (res && res.data) {
      dispatch(setBanner(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

export const UpdateGame = (id, payload) => async (dispatch) => {
  try {
    const res = await axios.put(`/private/backend/website/game/${id}`, payload);
    if (res && res.data) {
      dispatch(setGame(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

// Delete payment method
export const DeleteBannerMethod = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/private/backend/website/banner/${id}`);
    if (res && res.data) {
      dispatch(removeBanner(id));
      toast.success("Banner deleted successfully");
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    dispatch(fetchFailure(errorMessage));
    return null;
  }
};

export const DeleteGame = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/private/backend/website/game/${id}`);
    if (res && res.data) {
      dispatch(removeGame(id));
      toast.success("Game deleted successfully");
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    dispatch(fetchFailure(errorMessage));
    return null;
  }
};

export const GetWebsiteData = () => async (dispatch) => {
  try {
    dispatch(fetchStart());

    const res = await axios.get("/private/backend/website");

    dispatch(fetchSuccess(res.data));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
  }
};

export default Website.reducer;
